<template>
<div class="comment-modal__content">

  <div class="comment-modal__content__header violation">
    <div class="comment-modal-title" v-if="this.layer === 'edit' || this.layer === 'check'">コメントを報告する</div>
    <div class="comment-modal-title" v-if="this.layer === 'thanks'">コメントを報告しました</div>
  </div><!-- /.modal__content__header -->

  <!-- 通報 入力セット ▼ -->
  <div class="comment-modal__content__body violation" v-if="this.layer === 'edit'">
    <fieldset>
      <legend>違反内容 <span class="tag tag-required">必須</span></legend>
      <ul class="violation__report">
        <li class="violation__report-item" v-for="(radio, index) in radioOptions" :key="index">
          <input type="radio" name="violation-report" :id="'item' + index" :value="radio.value" v-model="postReport">
          <label :for="'item' + index">{{radio.label}}</label>
        </li>
      </ul>
    </fieldset>

    <fieldset>
      <legend>違反内容の詳細</legend>
      <!-- 違反内容の詳細 入力 -->
      <div class="violation__comment">
        <textarea class="textarea" :class="{ 'textarea--error': this.isErrorClass }" placeholder="コメントを入力してください。" v-model="postComment"></textarea>
        <div class="textarea__count" :class="{ 'textarea__count--error': this.isErrorClass }">{{commentLength}}/{{postCommentMax -1}}</div>
      </div>
    </fieldset>
  </div><!-- /.modal__content__body -->

  <div class="comment-modal__content__footer" v-if="this.layer === 'edit'">
    <!-- 通報操作ボタン キャンセル -->
    <div class="comment-modal-btn-group">
      <button class="btn btn-edit" type="button" @click="hideModal"><span class="btn-text">キャンセル</span></button>
    </div>
    <!-- 通報操作ボタン 入力 -->
    <div class="comment-modal-btn-group">
      <button class="btn btn-has-bg btn-check" type="button" :disabled="this.isBtnDisabled" @click="check"><span class="btn-text">確認</span></button>
    </div>
  </div><!-- /.modal__content__footer -->
  <!-- 通報 入力セット ▲ -->

  <!-- 通報 確認セット ▼ -->
  <div class="comment-modal__content__body violation" v-if="this.layer === 'check'">
    <p class="comment-modal-text">下記内容で報告を送信してよいか確認してください。</p>
    <fieldset>
      <legend>違反内容</legend>
      <ul class="violation__report">
        <li class="violation__report-item">
          {{radioOptions[postReport - 1].label}}
        </li>
      </ul>
    </fieldset>

    <fieldset>
      <legend>違反内容の詳細</legend>
      <!-- 違反内容の詳細 確認 -->
      <div class="violation__comment">
        <p class="comment-modal-text-check" v-text="postComment"></p>
      </div>
    </fieldset>
  </div><!-- /.modal__content__body 確認 -->

  <div class="comment-modal__content__footer" v-if="this.layer === 'check'">
    <!-- 通報操作ボタン キャンセル -->
    <div class="comment-modal-btn-group"></div>
    <!-- 通報操作ボタン 確認 -->
    <div class="comment-modal-btn-group">
      <button class="btn btn-edit" type="button" @click="edit"><span class="btn-text">編集</span></button>
      <button class="btn btn-has-bg btn-submit" type="button" @click="submit" :disabled="reportDisabled"><span class="btn-text">投稿</span></button>
    </div>
  </div><!-- /.modal__content__footer -->
  <!-- 通報 確認セット ▲ -->

  <!-- 通報 通報後セット ▼ -->
  <div class="comment-modal__content__body violation" v-if="this.layer === 'thanks'">
    <p class="comment-modal-text">
      ※いただいた報告が第三者に知られることはありません。<br>
      ※いただいた報告にJ-CASTが個別にお答えすることはありません。<br>
      ※いただいた報告に基づいてJ-CASTが対応、処置することをお約束するものではありません。
    </p>
  </div>

  <div class="comment-modal__content__footer" v-if="this.layer === 'thanks'">
    <!-- 通報操作ボタン キャンセル -->
    <div class="comment-modal-btn-group"></div>
    <!-- 通報操作ボタン 確認 -->
    <div class="comment-modal-btn-group">
      <button class="btn btn-edit" type="button" @click="hideModal"><span class="btn-text">OK</span></button>
    </div>
  </div><!-- /.modal__content__footer -->
  <!-- 通報 通報後セット ▲ -->

</div>
</template>

<script>
import api from '@/api/commentApi'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'modalReport',
  data: function () {
    return {
      layer: 'edit',
      postReport: '',
      postComment: '',
      postCommentMax: 101,
      radioOptions: [
        { label: '宣伝・広告的利用', value: 1 },
        { label: '不適切・攻撃的な内容', value: 2 },
        { label: '悪質なリンク', value: 3 },
        { label: 'スパム行為', value: 4 },
        { label: '個人情報保護の観点から', value: 5 }
      ],
      reportDisabled: false
    }
  },
  computed: {
    ...mapState('commentsData', ['entryID', 'entryUrl', 'entryTitle']),
    ...mapState('modal', ['reportUuid', 'reportReplyKey']),
    commentLength: function () {
      return this.postComment.length
    },
    isBtnDisabled: function () {
      // 通報内容+通報コメント数が0以上max以下 true
      const count = this.postComment.length
      const isCheckBtnDisabled = !(count < this.postCommentMax && this.postReport !== '')
      return isCheckBtnDisabled
    },
    isErrorClass: function () {
      // コメント数がmax以上
      const count = this.postComment.length
      const isErrorClass = count > this.postCommentMax - 1
      return isErrorClass
    }
  },
  methods: {
    ...mapMutations('modal', ['setModalError', 'hideModal']),
    ...mapActions('commentsData', ['reportSubmit']),
    check: function () {
      // layer変更
      this.layer = 'check'

      // scriptタグ除去
      const removalScriptStr = this.postComment.replace(/<script>|<\/script>|<script[^>]+?>|<script(.|\s)*?\/script>/gi, '')
      // コメントアップデート
      this.postComment = removalScriptStr
    },
    edit: function () {
      this.layer = 'edit'
    },
    submit: function () {
      // 通報するコメントは、主か返信かを reportReplyKeyで判定
      const postReport = {
        'entryID': this.entryID,
        'postBody': {'report': this.postReport, 'comment': this.postComment},
        'replyReportFlag': (this.reportReplyKey !== undefined),
        'uuid': this.reportUuid,
        'replyKey': this.reportReplyKey
      }

      // 処理中はdisabled
      this.reportDisabled = true
      // apiのみ利用するので vuex は利用しない
      api.postReport(postReport).then(entry => {
        // cx 報告 送信
        global.cX.callQueue.push(['sendEvent', 'jct-news_report_comment', { url: this.entryUrl, title: this.entryTitle, comment_id: postReport.uuid }])

        // console.log('postReport成功')
        this.layer = 'thanks'
        this.postComment = ''
        this.reportDisabled = false
      }).catch(error => {
        // console.log('postReport失敗')
        // this.layer = 'edit'
        // モーダル消す
        this.hideModal()
        // エラーモーダル表示
        const errorMessage = (error.data !== undefined) ? error.data.error : 'Error'
        this.setModalError({ name: 'modalError', message: errorMessage })
        this.reportDisabled = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/modal/modalReport.vue